import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=459c4a9c&scoped=true"
import script from "./Col.vue?vue&type=script&lang=ts"
export * from "./Col.vue?vue&type=script&lang=ts"
import style0 from "./Col.vue?vue&type=style&index=0&id=459c4a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c4a9c",
  null
  
)

export default component.exports